import React, {useEffect, useState }   from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { ListGroup }   from 'react-bootstrap';
import Grid            from '@material-ui/core/Grid';
import Toolbar          from '@material-ui/core/Toolbar';
import ImageList       from '@material-ui/core/ImageList';   //2021.11.27 Material-UIのツール名称変更（GridList→ImageList）に伴い変更
import Button          from '@material-ui/core/Button';
import Modal           from '@material-ui/core/Modal';
import Fade            from '@material-ui/core/Fade';
import AppBar          from '@material-ui/core/AppBar';
import MedicalRecord   from '../components/MedicalRecord';
import FamikarHeader   from '../components/FamikarHeader';
import ModalFamilyView from '../components/ModalFamilyView';
import ModalInterview  from '../components/ModalInterview';
import InterviewImg    from '../img/clinical_f.svg'
import firebase        from 'firebase/compat/app';

///////////////////////////////
//// 2020.12.5 作成者：新井 ////
////   個人メンバー一覧画面  ////
//// memo : デバック用表示 console.log("好きな文字列");
///////////////////////////////

//メンバー一覧用
/**
 * 一覧取得中に組み立てる一時バッファ。
 * 既存実装に合わせて「まず配列に詰めて最後に state へ反映」するために使用。
 * @type {{ list: SymptomsRecord[] }}
 */
const SymptomsList = { list: [] }

/**
 * 個人ホームで表示する症状カード（診療情報）1件の表示用データ。
 * @typedef {Object} SymptomsRecord
 * @property {Date|null} CreateTime 登録日
 * @property {string} Diagnosis 診断結果（旧互換）
 * @property {string} First_FollowUp 初回経過情報参照先のドキュメントパス
 * @property {string} Fever_Degrees 発熱時の体温
 * @property {string} HospitalName 医療機関名（MedicalResultsがあれば最新で補完）
 * @property {string} MedicalRecordId 症状カードID
 * @property {string} MedicalSpecialty 診療科（MedicalResultsがあれば最新で補完）
 * @property {string} MemberID メンバーID
 * @property {string} Note 備考（問診票メモ）
 * @property {string} Reason_for_Consultation 受診理由（設計優先）
 * @property {string} Title 病名（旧表示・互換用）
 * @property {Date|null} UpdateTime 更新日
 * @property {string} memberName 表示名
 * @property {string} member_url メンバーアイコンURL
 * @property {string} uid ログインユーザーuid
 */

/**
 * モーダル表示状態。
 * @typedef {Object} ModalShowsState
 * @property {boolean} Interview 問診票モーダル表示フラグ
 * @property {boolean} FamilyView 基本情報モーダル表示フラグ
 */

/** @type {string[]} 家族ID(配列)（Person から取得した家族IDの一時保持） */
var familyIDs   = []
/** @type {string} 家族ID（一覧取得・遷移等で使用する一時保持） */
var familyID    = ''
// 名前・名字は画面内では未使用のため保持しない
/** @type {string} ログインユーザーuid（一時保持） */
var uid         = ''
/** @type {string} メンバーの表示名（一時保持） */
var displayName = ''
/** @type {string} メンバーアイコン画像パス（一時保持） */
var member_url  = ''
const envLabel = process.env.REACT_APP_ENV_LABEL || ''

/**
 * PersonalHome: 個人ホーム画面コンポーネント
 *
 * 役割:
 * - 指定メンバーの基本情報と受診（症状カード）一覧を表示
 * - 問診票登録（`ModalInterview`）と基本情報表示（`ModalFamilyView`）のモーダル制御
 * - ログイン状態の確認と、必要に応じた遷移（`/FamilyHome/:FamilyID` or `/Login`）
 *
 * ルーティングパラメータ:
 * - `MemberID`: 表示対象メンバーID（未指定時は家族ホームへ遷移）
 *
 * 主な状態:
 * - `uid`, `FamilyID`, `DisplayName`, `member_url`: 表示・遷移に必要な識別情報
 * - `symptomsList`: 症状カード（診療記録）一覧
 * - `ModalShows`: モーダルの表示状態（`Interview`, `FamilyView`）
 */
export default function PersonalHome(props){
  /** @type {import('react-router-dom').NavigateFunction} 画面遷移関数 */
  const navigate = useNavigate()
  /** @type {import('react-router-dom').Location} ルーティングの state/現在地参照 */
  const location = useLocation()
  /** @type {{ MemberID?: string }} URLパラメータ（表示対象のメンバーID） */
  const { MemberID } = useParams()
  // console.log('MemberID:' + MemberID)
  /** @type {[string, import('react').Dispatch<import('react').SetStateAction<string>>]} ログインユーザーのuid（表示・Firestore参照に使用） */
  const [ Uid,          setUid          ] = useState((location.state !== null && location.state.uid         !== '') ? location.state.uid         : '')
  /** @type {[string, import('react').Dispatch<import('react').SetStateAction<string>>]} 診療情報登録対象の家族ID */
  const [ FamilyID,     setFamilyID     ] = useState((location.state !== null && location.state.familyID    !== '') ? location.state.familyID    : '')
  /** @type {[string, import('react').Dispatch<import('react').SetStateAction<string>>]} 診療情報登録対象の表示名 */
  const [ DisplayName,  setDisplayName  ] = useState((location.state !== null && location.state.DisplayName !== '') ? location.state.DisplayName : '')
  /** @type {[string, import('react').Dispatch<import('react').SetStateAction<string>>]} 診療情報登録対象のアイコン画像パス */
  const [ Member_url,   setMember_url   ] = useState((location.state !== null && location.state.member_url  !== '') ? location.state.member_url  : '')
  /** @type {[string, import('react').Dispatch<import('react').SetStateAction<string>>]} 診療情報登録対象のメンバーID */
  const [ memberID,     setMemberID     ] = useState(MemberID ? MemberID : '')
  /** @type {[SymptomsRecord[], import('react').Dispatch<import('react').SetStateAction<SymptomsRecord[]>>]} 症状カード（診療情報）一覧 */
  const [ symptomsList, setSymptomsList ] = useState([{
    CreateTime:      new Date(), //登録日
    Diagnosis:        '', // 診断結果
    First_FollowUp:   '', // 初回経過情報参照先のドキュメントパス
    Fever_Degrees:    '', // 発熱時の体温
    HospitalName:     '', // 病院名
    MedicalRecordId:  '', // 症状カードID
    MedicalSpecialty: '', // 診療科
    MemberID:         '', // メンバーID
    Title:            '', // 病名
    UpdateTime:      new Date(), //更新日
    memberName:       '', // 表示名
    member_url:       '', // メンバー画像URL
    uid:              '', // ログインユーザーuid
    // DisplayName:      '', // 表示名
    // FamilyID:         '', // 家族ID
    //Interview_state: '', // 問診票の取扱状態（'New'=新規作成, 'View'=表示, 'Edit'=編集）
  }])
  /** @type {[ModalShowsState, import('react').Dispatch<import('react').SetStateAction<ModalShowsState>>]} モーダル表示状態 */
  const [ ModalShows, setModalShows ] = useState({
    'Interview':  false,
    'FamilyView': false
  })

  // console.log(`PersonalHome state[${JSON.stringify(location.state,null,'\t')}]`);
  // console.log(`PersonalHome uid[${uid}]`);
  // console.log(`PersonalHome FamilyID[${FamilyID}]`);
  // console.log(`PersonalHome memberID[${memberID}]`);
  // console.log("PersonalHome member_url["+member_url+"]");
  // console.log(`PersonalHome DisplayName[${DisplayName}]`);
 
  /******************/
  // ログイン情報取得
  /******************/
  /**
   * ログイン情報取得: 現在の認証ユーザーを監視し、取得後にユーザー情報取得処理を連鎖実行。
   * @param {firebase.firestore.Firestore} db Firestoreインスタンス
   * @returns {void}
   */
  const getLoginInfo = (db) => {
    firebase.auth().onAuthStateChanged(async(user)=>{ //現在ログインしているユーザーを取得する。
      if(user){ 
        uid = user.uid
        console.log(`getLoginInfo() uid: ${uid}`)
        await getPersonInfo(db) //ユーザー情報取得
      }
    })
  }

  /******************/
  // ユーザー情報取得
  /******************/
  /**
   * ユーザー情報取得: `Person/{uid}` を取得し、家族ID・氏名などを準備。
   * - `MemberID` が未指定の場合は `/FamilyHome/:FamilyID` へ遷移。
   * - 指定されていればメンバー情報取得へ。
   * @param {firebase.firestore.Firestore} db Firestoreインスタンス
   * @returns {Promise<void>}
   */
  const getPersonInfo = async(db) =>{
    //console.log(`getPersonInfo() uid: ${uid}`)
    // ログインユーザー情報取得
    console.log(`getPersonInfo() uid: ${uid}`)
    db.collection("Person").doc(uid).get().then(async(result)=>{
      var data = result.data()
      familyIDs = [] // 家族ID(配列)
      familyIDs.push(data.FamilyID[0].id) //1件目の家族IDを取得する。
      // 名前・名字はここでは使用しない
      familyID   = familyIDs[0]    // 家族ID
      // console.log(`familyIDs: ${familyIDs[0]}`)
      // console.log(`familyID: ${familyID}`)
      // console.log(`firstname: ${firstName}`)
      // console.log(`familyname: ${familyName}`)
      if (MemberID !== '') {
        getMemberInfo(db) //メンバー情報取得
      } else {
        console.log("push URL: /FamilyHome/" + familyID)
        navigate('/FamilyHome/' + familyID) //ログイン中でメンバーIDが無い場合は、家族ホーム画面に移動する。
      }
      
    })
  }


  /******************/
  // メンバー情報取得
  /******************/
  /**
   * メンバー情報取得: `Family/{FamilyID}/Member/{MemberID}` を取得し、表示名とアイコンURLを設定。
   * 取得後にページタイトルを設定し、症状カード一覧取得を実行。
   * @param {firebase.firestore.Firestore} db Firestoreインスタンス
   * @returns {void}
   */
  const getMemberInfo = (db) => {
    db.collection("Family").doc(familyID).collection("Member").doc(memberID)
    .get().then((result)=>{
      var data = result.data()
      displayName = data.DisplayName //メンバー表示名
      member_url  = data.image_url   //メンバーアイコン画像URL
      document.title = `${(displayName) ? displayName : '◯◯'}の個人ホーム - ふぁみかるくん${envLabel}`
      getSymptomsList(db) // 症状カード情報取得
    })
  }

  /******************/
  // 家族ホーム画面に戻る
  /******************/
  /**
   * 家族ホームへ戻る: ログイン状態を確認し、適切な画面へ遷移。
   * @param {Event} e クリックイベント
   * @returns {void}
   */
  const handleGoBack = (e) =>{
    UserStatusCheck() //ログイン状態チェック
  }

  // ログイン状態チェック
  /**
   * ログイン状態チェック: 認証状態に応じて遷移を行う。
   * - ログイン中: `Person/{uid}` から家族ID取得後 `/FamilyHome/:FamilyID` へ。
   * - 未ログイン: セッションをクリアし `/Login` へ。
   * @returns {void}
   */
  const UserStatusCheck=()=>{
    firebase.auth().onAuthStateChanged((user)=>{
      if (user) {
        const db = firebase.firestore();
        var _FamilyID = '';
        db.collection("Person").doc(user.uid).get().then((result)=>{
          _FamilyID = result.data().FamilyID[0].id //1件目の家族IDを取得する。
          console.log("push URL: /FamilyHome/" + _FamilyID)
          navigate('/FamilyHome/' + _FamilyID) //ログイン中の場合は、家族ホーム画面に移動する。
        })
      } else {
        sessionStorage.clear() //ログインページのリロード管理用のローカルストレージを削除する。
        console.log("push URL: /Login")
        navigate('/Login') //ログイン中でなければ、ログイン画面に移動する。
      }
    })
  }

  /******************/
  // 症状情報取得リスト
  /******************/
  /**
   * 症状カード一覧取得: `MedicalRecords` を家族ID・メンバーIDで絞り込み取得。
   * - `DeleteFlag` が立っていないレコードのみを採用。
   * - 診察結果（`MedicalResults`）が登録されている場合は、最新の「受診医療機関」「診療科」を一覧に反映。
   * - 取得後に時系列を反転し、表示用ステート各種をまとめて更新。
   * @param {firebase.firestore.Firestore} db Firestoreインスタンス
   * @returns {void}
   */
  const getSymptomsList = async (db) => {
    try {
      const result = await db.collection("MedicalRecords")
        .where("FamilyID", "==", familyID)
        .where("MemberID", "==", memberID)
        .get()

      SymptomsList.list = []

      result.forEach((doc) => {
        const dataT = doc.data()
        const DeleteFlag = (dataT.DeleteFlag == null) ? false : dataT.DeleteFlag // 削除フラグがある場合は非表示
        if (DeleteFlag !== false) return

        SymptomsList.list.push({
          CreateTime: (dataT.CreateTime == null) ? null : dataT.CreateTime.toDate(), // 登録日（問診票登録日）
          Diagnosis: dataT.Diagnosis, // 診断結果（旧）
          First_FollowUp: (dataT.First_FollowUp && dataT.First_FollowUp.path) ? dataT.First_FollowUp.path : '',
          Fever_Degrees: (dataT.InterviewSheet && ("Fever_Degrees" in dataT.InterviewSheet)) ? dataT.InterviewSheet.Fever_Degrees : '',

          // 受診医療機関・診療科（旧: MedicalRecords直下 / 新: MedicalResultsから補完）
          HospitalName: dataT.HospitalName || '',
          MedicalSpecialty: dataT.MedicalSpecialty || '',

          MedicalRecordId: doc.id,
          MemberID: dataT.MemberID,
          Note: (dataT.InterviewSheet && ("Note" in dataT.InterviewSheet)) ? dataT.InterviewSheet.Note : '',

          // 受診理由（設計優先）
          Reason_for_Consultation: dataT.Reason_for_Consultation || '',

          Title: dataT.Title, // 旧表示（互換用）
          UpdateTime: (dataT.UpdateTime == null) ? null : dataT.UpdateTime.toDate(),
          memberName: displayName,
          member_url: member_url,
          uid: uid,
        })
      })

      // 診察結果（MedicalResults）から最新の医療機関・診療科を補完
      const enrichWithLatestMedicalResult = async (record) => {
        try {
          const snap = await db.collection("MedicalRecords").doc(record.MedicalRecordId)
            .collection("MedicalResults")
            .orderBy("UpdateTime", "desc")
            .limit(1)
            .get()

          if (snap.empty) return record

          const latest = snap.docs[0].data() || {}
          const hospitalName = latest.HospitalName || ''
          const medicalSpecialty = latest.MedicalSpecialty || ''

          if (hospitalName === '' && medicalSpecialty === '') return record

          return {
            ...record,
            HospitalName: hospitalName,
            MedicalSpecialty: medicalSpecialty,
          }
        } catch (e) {
          // インデックス不足等で失敗した場合は補完しない（一覧表示は継続）
          return record
        }
      }

      const enrichedList = await Promise.all(SymptomsList.list.map(enrichWithLatestMedicalResult))

      enrichedList.reverse() // 取得順を逆転して最新を先頭にする

      setUid(uid)
      setFamilyID(familyID)
      setDisplayName(displayName)
      setMember_url(member_url)
      setSymptomsList(enrichedList)
    } catch (error) {
      console.log("Error getting medical record documents: ", error)
    }
  }
  
  /**
   * 更新・削除用のモーダルを展開
   * @param {*} view "FamilyView"：基本情報、"Interview"：問診
   * @param {*} docId 更新/削除対象データのDocID
   */
   // handleUpdateModalOpen = (view,docId) =>{
  /**
   * モーダル表示制御: 指定ビューに応じて対象モーダルを開く。
   * @param {('FamilyView'|'Interview')} view 表示対象モーダル
   * @returns {void}
   */
   const handleNewModalOpen = (view) =>{
    switch(view) {
      case "FamilyView":
        setModalShows({
          'Interview':  false,
          'FamilyView': true
        })
        break
  
      case "Interview":
        setModalShows({
          'Interview':  true,
          'FamilyView': false
        })
        break
  
      default:
        break
    }
  };
  
  /**
   * 各種モーダルを閉じる
   */
   /**
    * モーダルを閉じる: すべてのモーダル表示フラグをオフにする。
    * @returns {void}
    */
   const handleModalClose = () => {
    setModalShows({
      'Interview':  false,
      'FamilyView': false
    })
  }

  /**
   * 各種モーダルを閉じて、画面内データを再読み込みする。
   */
   /**
    * モーダルを閉じて再読込: すべてのモーダルを閉じた後、症状カード一覧を再取得。
    * @returns {void}
    */
   const handleReloadModalClose = () => {
    setModalShows({
      'Interview':  false,
      'FamilyView': false
    })
    getSymptomsList(firebase.firestore()) //症状カード情報の再読み込みを行う。
  }

  useEffect(() => { //ページ表示時、情報更新時に実行
    // componentDidMount のタイミングで実行したい処理を記述
    //console.log("compoonentDidMount: FamilyID[" + FamilyID + "]")
    const db = firebase.firestore();
    getLoginInfo(db) // ログイン情報取得
    // 次の行のコメントでeslintの余分なワーニングを抑制する。
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setUid, setFamilyID, setMemberID]);

  useEffect(() => { //ページを離れる際に実行
    // componentDidMount のタイミングで実行したい処理を記述
    return () => {
      // componentWillUnmount のタイミングで実行したい処理を記述
      document.title = 'ふぁみかるくん' //家族ホーム画面を離れる際、ページタイトルを初期値に戻す
    }
  }, []);

  /******************/
  // 画面表示
  /******************/
  return (
    <React.Fragment>
    {Uid !== '' ? <FamikarHeader uid={Uid} FamilyID={FamilyID} isHome={false} /> : null}
    {/* 家族の情報をモーダル表示で対応する。 */}
    {/* {console.log("DispName["+DisplayName+"] ")} */}
    {/* {console.log("uid["+uid+"] ")} */}
    {/* {console.log("FamilyID["+FamilyID+"] ")} */}
    {/* {console.log("MemberID["+MemberID+"] ")} */}
    <Grid container alignItems="center" style={{padding: "10px 8px 10px"}}>
      <Grid item xs={9} style={{textAlign: "left"}}>
        <h5 style={{margin: "0px auto"}}>
          <span style={{textDecoration: "underline"}}>
          {(DisplayName !== '') ? `${DisplayName}` : ''}
          </span>
        </h5>
      </Grid>
      <Grid item xs={3} style={{textAlign: "right"}}>
        <Button style={{margin: "0px 0px", padding: "6px 12px"}} variant="outlined" color="primary" onClick={()=>handleNewModalOpen('FamilyView')}>基本情報</Button>
      </Grid>
    </Grid>
    <Grid style={{textAlign: "left", padding: '0 8px'}}><label style={{fontWeight:"bold"}}>受診一覧</label></Grid>

    <Grid container spacing={0} style={{margin: "8px 0 16px"}}>
      <Grid item xs={12}>
        <Button variant="contained" style={{width: "calc(100% - 16px)", padding: "10px 0px", backgroundColor: '#d9d2e9'}} onClick={()=>handleNewModalOpen('Interview')}>
          ＋<img src={InterviewImg} alt="問診票登録" width="35px" />&nbsp;問診票を登録しましょう
        </Button>
      </Grid>
    </Grid>
    
    <Grid container spacing={2} justifyContent="space-between" alignItems="stretch">
      <Grid item xs={12}>
        <ImageList cols = {1} as="ul">
          {/* {symptomsList} */}
          {/* {console.log(symptomsList)} */}
          {symptomsList.map((symptoms)=>(
            // console.log(symptoms.MedicalRecordId)
            symptoms.MedicalRecordId !== '' 
            ? <ListGroup.Item as="li" className="justify-md-left align-left" key={symptoms.MedicalRecordId} style={{height: '100px'}}>
              <MedicalRecord record={symptoms} FamilyID={FamilyID} />
            </ListGroup.Item>
            : null
          ))}
        </ImageList>
      </Grid>
      <Grid item xs={12} style={{height: '65px'}} />
    </Grid>

    {/* 画面下部のメニュー */}
    <Toolbar />
    <AppBar position="fixed" style={{backgroundColor: '#FFFFFF', top: 'auto', bottom: '0', boxShadow: 'none'}}>
      <Grid Grid container justifyContent="space-between" alignItems="flex-start" style={{padding: '16px 8px 8px', maxWidth: '480px'}} className="App">
        <div>　</div>
        <Button variant="contained" color="primary"   onClick={()=>handleGoBack()}>戻る</Button>
      </Grid>
    </AppBar>
    {/* {console.log(ModalShows)} */}
    {/* {console.log(ModalShows.FamilyView)} */}
    {/* {console.log("ModalShows.FamilyView:"+ModalShows.FamilyView)} */}
    
    {/* <Modal open={ModalShows.FamilyView} onClose={()=>handleModalClose()} className={useStyles.theme.modal}> */}
    {/* <Modal open={ModalShows.FamilyView} onClose={()=>handleModalClose()} style={{maxHeight: '100%', overflowY: 'auto'}}> */}
    <Modal
      open={ModalShows.FamilyView}
      onClose={()=>handleModalClose()} 
      style={{
        maxHeight: '100%', 
        overflowY: 'auto',
      }}>
      <Fade in={ModalShows.FamilyView}>
        {/* <div className={this.props.classes.paper}> */}
        <div style={{
          position: 'relative',
          display: 'block',
          top: '0',
          left: '50%',
          outline: 'none',
          transform: 'translate(calc(-50% - 0.5rem ), 0)',
          backgroundColor: 'white',
          border: '1px solid rgba(0,0,0,.2)',
          // boxShadow: theme.shadows[5],
          // padding: theme.spacing(3, 2, 3),
          margin: '1.75rem 0rem',
          maxWidth: '460px',
          width: 'calc(100% - 1rem)',
          borderRadius: '.3rem',
          overflowY: 'visible'
        }}>
          <ModalFamilyView handleModalClose={()=>handleModalClose()} DisplayName={DisplayName} image_src={Member_url}
            uid={Uid} FamilyID={FamilyID} MemberID={MemberID} />
        </div>
      </Fade>
    </Modal>
    

    {/* <Modal open={ModalShows.Interview} onClose={this.handleModalClose} className={this.props.classes.modal}> */}

    <Modal open={ModalShows.Interview} onClose={()=>handleModalClose()} style={{maxHeight: '100%', overflowY: 'auto'}}>
      <Fade in={ModalShows.Interview}>
        {/* <div className={this.props.classes.paper}> */}
        <div style={{
          position: 'relative',
          display: 'block',
          top: '0',
          left: '50%',
          padding: '10px',
          outline: 'none',
          transform: 'translate(calc(-50% - 0.5rem), 0)',
          backgroundColor: 'white',
          border: '1px solid rgba(0,0,0,.2)',
          // boxShadow: theme.shadows[5],
          // padding: theme.spacing(3, 2, 3),
          margin: '1rem .5rem',
          maxWidth: '460px',
          width: 'calc(100% - 1rem)',
          borderRadius: '.3rem',
          overflowY: 'visible'
        }}>
          <ModalInterview handleModalClose={()=>handleModalClose()} handleReloadModalClose={()=>handleReloadModalClose()}
            /*className={this.props.classes.float}*/ uid={Uid} MemberID={MemberID} FamilyID={FamilyID}
            DisplayName={DisplayName} member_url={Member_url} Interview_state='New'
          />
        </div>
      </Fade>
    </Modal>
  </React.Fragment>

  )


}
